<template>
    <va-create-layout>
        <RefundEvent-form :title="title" :item="item"></RefundEvent-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
